import { render } from "./AddToCatalogModal.vue?vue&type=template&id=01084c5c&ts=true"
import script from "./AddToCatalogModal.vue?vue&type=script&lang=ts"
export * from "./AddToCatalogModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Data\\TCF\\ABBp_PIS\\6.12\\PisNextGenExtTrain-PisApp_6_12_0\\PisNextGenExtTrain\\PisNextGen\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__